import React from 'react';
// import { LinkProvider } from '../useLink';
import I18nProvider from './lingui/I18nProvider';

export default function wrapPageElement({ element, props }) {
  // const paths = props.pageContext?.paths;
  return (
    <I18nProvider {...props.pageContext}>
      {/* <LinkProvider
        value={(context) =>
          context || paths ? { ...context, ...paths } : undefined
        }
      > */}
      {element}
      {/* </LinkProvider> */}
    </I18nProvider>
  );
}
